function convertMonthToAbbr(el) {
    var $dateMonth = document.querySelectorAll(el);
    for (var i = 0; i < $dateMonth.length; i++) {
        var mo = $dateMonth[i].textContent;
        
        switch ($dateMonth[i].textContent.toLowerCase()) {
            case 'january':
                mo = 'Jan';
                break;
            case 'february':
                mo = 'Feb';
                break;
            case 'march':
                mo = 'Mar';
                break;
            case 'april':
                mo = 'Apr';
                break;
            case 'august':
                mo = 'Aug';
                break;
            case 'september':
                mo = 'Sept';
                break;
            case 'october':
                mo = 'Oct';
                break;
            case 'november':
                mo = 'Nov';
                break;
            case 'december':
                mo = 'Dec';
        }
        $dateMonth[i].textContent = mo;
    }    
}

convertMonthToAbbr('.card-date__month');